import BasicSectionTitle from './Basic'
import SubsectionTitle from './Subsection'

export { BasicSectionTitle, SubsectionTitle }
